import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=12e70605&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"
import style0 from "./HeaderTemplate.vue?vue&type=style&index=0&id=12e70605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e70605",
  null
  
)

export default component.exports